module.exports = __webpack_public_path__ + "static/cercazone_centro2-55e344a05d8c62be70dfdd714bb8e8e9.jpg";